import { BUSINESSES_ROUTES } from '../../constants/_routes'
import businessesTypes from '../../constants/businessesTypes'
import { axios } from '../../services'
import { current_timestamp } from '../../helpers'

// INDEX
const businesses_index_request = () => {
  return {
    type: businessesTypes.index.request
  }
}

const businesses_index_success = (response) => {
  return {
    type: businessesTypes.index.success,
    payload: response.data
  }
}

const businesses_index_failure = (messages) => {
  return {
    type: businessesTypes.index.failure,
    payload: messages
  }
}

const businesses_index = (page=1, per_page=10, filters={}, sort="", order="") => {
  return function (dispatch) {
    // Before Request
    dispatch(businesses_index_request())

    // Request
    axios.get(
      BUSINESSES_ROUTES.index,
      {
        params: {
          page: page,
          per_page: per_page,
          sort: sort,
          order: order,
          filters: filters,
          serial: current_timestamp()
        }
      }
    ).then( response => {
      // success
      dispatch( businesses_index_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching businesses."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( businesses_index_failure(errors))
    })
  }

}

const businesses_select_success = (response) => {
  return {
    type: businessesTypes.index.select,
    payload: response.data
  }
}


const businesses_select = () => {
  return function (dispatch) {
    // Before Request
    dispatch(businesses_index_request())

    // Request
    axios.get(
      BUSINESSES_ROUTES.select
    ).then( response => {
      // success
      dispatch( businesses_select_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching businesses."]
      }
      dispatch( businesses_index_failure(errors))
    })
  }
}

export {
  businesses_index,
  businesses_select
}



// WEBPACK FOOTER //
// ./src/js/actions/businesses/getindex.js